export const parseMouseButtons = (buttons: number) => {
  if (buttons === 1) return 'left';
  if (buttons === 2) return 'right';
  if (buttons === 3) return 'both';
  if (buttons === 4) return 'middle';
  return 'none';
};

export const parseMouseButton = (button: number) => {
  if (button === 0) return 'left';
  if (button === 1) return 'middle';
  if (button === 2) return 'right';
  return 'none';
};
